import styled from "styled-components";

export const Background = styled.div`
  background-color: #f9f9f9;
  border-color: #efefef;
  margin-bottom: 20px;

  @media print { 
    display: none;
  }
`;

export const Layout = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 0;
`

export const FormattedDate = styled.div`
  font-size: 1em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.75);

  @media screen and (max-width: 767px) {
    text-align: center;
  }
`

export const Greeting = styled.div`
  font-size: 1.1em;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);

  @media screen and (max-width: 767px) {
    text-align: center;
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const Button = styled.button`
  background-color: #00C19D;
  border: none;
  border-radius: 3px;
  color: #fff;
  display: block;
  padding: 6px 8px;
  min-width: 96px;
  font-weight: bold;
  text-align: center;
  font-size: 0.875em;
  text-transform: uppercase;
  cursor: pointer;
`;
